<template>
  <div class="p-4 bg-white rounded shadow">
    <div class="flex justify-between items-center mb-4">
      <h2 class="text-lg font-semibold">👥 รายชื่อผู้ใช้ทั้งหมด</h2>
    </div>

    <div class="overflow-x-auto">
      <table class="min-w-full border border-gray-200 rounded">
        <thead class="bg-gray-100 text-gray-600 text-sm">
          <tr>
            <th class="p-3 text-left">ชื่อ</th>
            <th class="p-3 text-left">เวลาคุยล่าสุด</th>
            <th class="p-3 text-left">Action</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="user in users"
            :key="user.user_id"
            class="hover:bg-gray-50 border-t"
          >
            <td class="p-3 flex items-center gap-2">
              <input
                type="checkbox"
                :value="user.user_id"
                v-model="selectedUsers"
              />
              <span>{{ user.name || '-' }}</span>

              <!-- ปุ่มคัดลอก UUID แบบซ่อน -->
              <button
                @click="copyToClipboard(user.user_uid)"
                class="text-xs text-gray-400 hover:underline ml-2"
                title="คัดลอก UUID"
              >
                📋
              </button>
            </td>
            <td class="p-3">
              <span v-if="user.last_chat">{{ formatDate(user.last_chat) }}</span>
              <span v-else class="text-gray-400 italic">ยังไม่เคยแชท</span>
            </td>
            <td class="p-3">
              <button
                @click="$emit('showChat', user)"
                class="bg-green-100 border-2 border-green-400 text-green-800 px-4 py-1 rounded-full text-sm font-medium flex items-center justify-center gap-1 hover:bg-green-200 transition"
              >
                💬 show chat
              </button>

            </td>
          </tr>
        </tbody>
      </table>

      <div v-if="showLocationOptionModal" class="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50">
        <div class="bg-white p-6 rounded-2xl shadow-xl w-[320px] text-center space-y-4">
          <h3 class="text-xl font-semibold text-gray-800">📍 ต้องการส่งแบบใด?</h3>
          <button @click="() => { fetchBranches(); showBranchListModal = true }" class="bg-gray-100 hover:bg-gray-200 px-4 py-2 rounded w-full">🔎 เลือกสาขา</button>
          <button @click="showLocationOptionModal = false" class="text-sm text-red-500 hover:underline">❌ ยกเลิก</button>
        </div>
      </div>

      <div v-if="showBranchListModal" class="fixed inset-0 bg-black bg-opacity-30 flex justify-center items-center z-50">
        <div class="bg-white w-[90%] max-w-md p-4 rounded-xl shadow max-h-[80vh] overflow-y-auto space-y-4">
          <h3 class="text-lg font-bold">🔎 เลือกสาขา</h3>
          <div v-for="branch in branches" :key="branch.location_id" class="border p-3 rounded shadow flex justify-between items-start">
            <div>
              <div class="font-semibold">{{ branch.location_name }}</div>
              <div class="text-xs text-gray-600">{{ branch.address }}</div>
            </div>
            <button @click="sendSingleBranchToUsers(branch.location_id)" class="bg-blue-500 text-white px-3 py-1 rounded text-sm">ส่ง</button>
          </div>
          <button @click="showBranchListModal = false" class="text-sm text-red-500 hover:underline">❌ ปิด</button>
        </div>
      </div>



      <!-- ช่องพิมพ์ข้อความ -->
      <div class="flex items-center mt-6 bg-gray-200 rounded-full px-2 py-2 shadow-sm">
        <!-- ปุ่ม + -->
        <div class="relative">
          <!-- ปุ่ม + -->
          <button
            class="bg-black text-white w-8 h-8 flex items-center justify-center rounded-full mr-2"
            title="เปิดเมนูเพิ่มเติม"
            @click="showMenu = !showMenu"
          >
            +
          </button>

          <!-- เมนูเด้งขึ้น -->
          <div
            v-if="showMenu"
            class="absolute bottom-10 left-0 bg-gray-200 p-2 rounded space-y-2 z-50 shadow"
          >
          <button @click="openLocationModal" class="block w-full bg-gray-300 rounded px-3 py-1 text-sm">location</button>
          <button class="block w-full bg-gray-300 rounded px-3 py-1 text-sm">promo</button>
            <button class="block w-full bg-gray-300 rounded px-3 py-1 text-sm">video</button>
            <button class="block w-full bg-gray-300 rounded px-3 py-1 text-sm">images</button>
            <button class="block w-full bg-gray-300 rounded px-3 py-1 text-sm">audio</button>
            <button class="block w-full bg-gray-300 rounded px-3 py-1 text-sm">sticker</button>
          </div>
        </div>

        <!-- input กล่องข้อความ -->
        <input
          type="text"
          v-model="newMessage"
          placeholder="พิมพ์ข้อความ..."
          class="flex-1 bg-transparent outline-none px-3 text-sm"
          @keyup.enter="sendMessage"
        />

        <!-- ปุ่มส่ง -->
        <button
          @click="sendMessage"
          class="bg-blue-600 hover:bg-blue-700 text-white w-8 h-8 rounded-full flex items-center justify-center"
          title="ส่งข้อความ"
        >
          <span class="text-white">➤</span>
        </button>
      </div>

    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "UserTable",
  data() {
    return {
      users: [],
      selectedUsers: [],
      loading: false,
      newMessage: '',
      showMenu: false,
      showLocationOptionModal: false,
      showBranchListModal: false,
      selectedBranchId: null,
      branches: [],
    };
  },
  async mounted() {
    try {
      const res = await axios.get("/api/users");
      this.users = res.data;
    } catch (err) {
      console.error("❌ โหลด users ไม่สำเร็จ:", err);
    }
  },
  methods: {
    formatDate(dateStr) {
      const d = new Date(dateStr);
      return d.toLocaleString("th-TH", {
        dateStyle: "short",
        timeStyle: "short",
      });
    },
    async sendMessage() {
      if (!this.newMessage.trim() || this.selectedUsers.length === 0) {
        alert("⚠️ กรุณากรอกข้อความและเลือกผู้ใช้");
        return;
      }

      try {
        for (const userId of this.selectedUsers) {
          await axios.post("/api/send-message", {
            userId,
            message: this.newMessage,
          });
        }

        alert("✅ ส่งข้อความเรียบร้อยแล้ว");
        this.newMessage = '';
        this.selectedUsers = [];
      } catch (err) {
        console.error("❌ ส่งข้อความล้มเหลว:", err);
        alert("❌ มีบางรายการส่งไม่สำเร็จ");
      }
    },
    copyToClipboard(text) {
      navigator.clipboard.writeText(text);
      alert("📋 คัดลอก UUID แล้ว");
    },
    openLocationModal() {
      if (this.selectedUsers.length === 0) {
        alert("⚠️ กรุณาเลือกผู้ใช้ก่อน");
        return;
      }
      this.showMenu = false;
      this.showLocationOptionModal = true;
    },
    async fetchBranches() {
      try {
        const res = await axios.get("/api/location");
        this.branches = res.data;
      } catch (err) {
        console.error("❌ โหลดสาขาล้มเหลว:", err);
      }
    },
    async sendSingleBranchToMultipleUsers() {
      try {
        if (!this.selectedBranchId || this.selectedUsers.length === 0) {
          alert("⚠️ กรุณาเลือกสาขาและผู้ใช้");
          return;
        }

        await axios.post("/api/admin/send-location-multi", {
          userIds: this.selectedUsers,
          branchId: this.selectedBranchId,
        });

        this.showBranchListModal = false;
        this.showMenu = false;
        this.selectedUsers = [];
        this.selectedBranchId = null;
        alert("✅ ส่งสาขาเรียบร้อยแล้ว");
      } catch (err) {
        console.error("❌ ส่งสาขาล้มเหลว:", err);
        alert("❌ ส่งสาขาไม่สำเร็จ");
      }
    }

  }
};
</script>


